import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@kizen/icons';

export default styled(FontAwesomeIcon)({
  margin: '0 !important',
});
